import { Component } from "react"

/* Widgets */
import RoundView from "../Round/RoundView"

/* Registry */
import { punto } from "../Round/registry"


/* Widget GameInformation — THE ROUND OF A PUNTO BANCO TABLE */
class GameInformation extends Component {

    render = () => {

        /* Fields */
        const { uid, gameID, postfix, socket } = this.props

        return <RoundView api={punto.api} config={punto} uid={uid} gameID={gameID} postfix={postfix} socket={socket} />
    }

}

export default GameInformation
